export const FETCH_VARIATIONS_FAILED = 'FETCH_VARIATIONS_FAILED';
export const FETCH_VARIATIONS_REQUEST = 'FETCH_VARIATIONS_REQUEST';
export const FETCH_VARIATIONS_SUCCESS = 'FETCH_VARIATIONS_SUCCESS';
export const FETCH_VARIATIONS_COMPLETE = 'FETCH_VARIATIONS_COMPLETE';
export const RESET_SELECTED_VARIATION = 'RESET_SELECTED_VARIATION';
export const SELECTED_VARIATION = 'SELECTED_VARIATION';
export const FETCH_SINGLE_VARIATION = 'FETCH_SINGLE_VARIATION';
